import React from 'react';

import { useGetAllCrops } from '@/modules/settings/shared/apiHooks';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const CropsSelector = () => {
  const [selectedAsset] = useStore((store) => store?.asset);
  const { data: crops } = useGetAllCrops(selectedAsset?.id);

  return (
    <div className='flex'>
      {crops?.list?.map((item) => (
        <span key={item.id}>{item.name} - </span>
      ))}
    </div>
  );
};
export { CropsSelector };
